export class OperatorConfigSettingDto {
  rId: number
  name: string
  configKey: ConfigSettingKey
  configValue: string
}

export enum ConfigSettingKey {
  //common config keys
  Logo = 'Logo',
  LogoWhite = 'LogoWhite',
  LogoWatermark = 'LogoWatermark',
  LoginBackground = 'LoginBackground',

  PreLoginFooterHtml = 'PreLoginFooterHtml',
  PostLoginFooterHtml = 'PostLoginFooterHtml',
  ContactUsHtml = 'ContactUsHtml',
  LoginPageLink = 'LoginPageLink',

  //other config keys
  ProgramGroupCardArt = 'ProgramGroupCardArt'
}